import React from 'react';

export const BattlePageHeader: React.FC<{
  title?: string;
  subtitle?: React.ReactNode;
  subtitleClassName?: string;
  extra?: React.ReactNode;
  below?: React.ReactNode;
  actions?: React.ReactNode;
}> = ({ title = 'Battle Badges', subtitle, subtitleClassName = 'bb-sub', extra, below, actions }) => (
  <header className="bb-header">
    <div className="bb-header-top">
      <div className="bb-header-start">
        <div className="bb-header-titles">
          <h1>{title}</h1>
          {subtitle != null && subtitle !== '' ? (
            <div className="bb-header-subrow">
              <p className={subtitleClassName}>{subtitle}</p>
            </div>
          ) : null}
          {extra}
        </div>
        {below}
      </div>
      <div className="bb-header-end">
        <div className="bb-header-actions">{actions}</div>
      </div>
    </div>
  </header>
);
